import * as React from "react";

type ContextValue = {
  path: string[];
  setPath: (path: string[]) => void;
};

export const Context = React.createContext<ContextValue>({
  path: [],
  setPath: () => {},
});

export const useContext = () => React.useContext(Context);
